import { Button, styled } from '@mui/material'

export const StyledLangButton = styled(Button)(({ theme }) => ({
  minWidth: 'initial',
  height: 24,
  background: 'none',
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
}))
